import { useDispatch, useSelector } from "react-redux"
import { IApplicationState } from "../../../Store"
import { FormulaireSchemaType } from "../validation/formulaire.schema"
import { saveFormulaire } from '../../../Store/Formulaire/Actions'
import { IFormulaireFranceState } from "../../../Store/Formulaire/Types"
import { zodToDomainMapper } from "./mappers/zod-to-domain.mapper"

export const useSaveFormulaire = () => {
    const dispatch = useDispatch()
    const formulaire = useSelector((state: IApplicationState) => state.formulaire.fr)
    const userInfo = useSelector((state: IApplicationState) => state.user.userInfo)

    //reverse of what we did in mapFormToFormulaireFrance with redux data
    //to decouple a bit the domain (redux) and the zod schema, maybe would be nice to refactor more globaly later
    const mapFormToFormulaireFrance = (form: FormulaireSchemaType, isValidated: boolean, isSigned: boolean, shouldDownload: boolean): IFormulaireFranceState => {
        const domainData = zodToDomainMapper.mapZodToDomain(form, formulaire)


        const updatedFormulaire: IFormulaireFranceState = {
            ...domainData,
            is_validated: isValidated,
            is_signed: isSigned,
            download: shouldDownload,
            user_id: userInfo.id,
            user_group: userInfo.parent_info.name,
            user_email: userInfo.email,
            society: {
                id: userInfo.id,
                name: userInfo.firstname,
                surname: userInfo.name,
                email: userInfo.email,
                date: new Date().toISOString().substring(0, 10),
                user_group_info: userInfo.parent_info,
                signature: '',
            }
        }
        return updatedFormulaire
    }

    const handleSaveFormulaire = (form: FormulaireSchemaType, isValidated: boolean, isSigned: boolean, shouldDownload: boolean) => {
        dispatch(saveFormulaire(mapFormToFormulaireFrance(form, isValidated, isSigned, shouldDownload)))
    }

    return {
        formulaire,
        saveFormulaire: handleSaveFormulaire
    }
}